export const PaymentConstants = {
    formNames: {
        SHIPPING_ADDRESS: 'shippingAddress',
        BILLING_ADDRESS: 'billingAddress',
        STRIPE_PAYMENT_METHOD: 'paymentMethod',
        CHECKOUT: 'checkout',
    },
    stripeFieldNames: {
        CARD_HOLDER_NAME: 'cardHolderName',
        CARD_NUMBER: 'cardNumber',
        CARD_EXP: 'cardExpiry',
        CARD_CVC: 'cardCvc',
    },
    stripeErrorCode: {
        CARD_NUMBER: 'invalid_number',
        CARD_EXP: 'invalid_expiry_year_past',
    },
    userAuthTypes: {
        GOOGLE: 'google',
        FACEBOOK: 'facebook',
        GUEST: 'guest',
    },
    apiEndpoints: {
        ACCOUNTS: '/accounts',
        ACCOUNT_NETWORKS: '/accountNetworks',
        TRANSACTIONS: '/paymentsTransactions',
    },
    networks: {
        STRIPE: 'stripe-customer',
    },
    transactionStatus: {
        NEW: 'new',
        CHARGED: 'charged',
        FAILED: 'failed',
    },
    httpVerb: {
        POST: 'postApi',
        PUT: 'putApi',
    },
    readButton: {
        MORE: {
            lines: 3,
            label: 'more',
        },
        LESS: {
            lines: -1,
            label: 'less',
        },
    },
    submitButtonLabels: {
        NEXT: 'Next',
        BUY: 'Buy',
        NA: 'Not Available',
    },
}
